import cx from 'classnames'

import Orientation from './OrientationIndicator'
import classes from './styles.module.scss'

type Props = {
  orientation?: 'landscape' | 'portrait' | 'both'
  activeCurrency: string
  isLoggedIn?: boolean
  isDarkMode?: boolean
  title: string
  captionClassName: string
}

function OrientationContainer({ orientation, activeCurrency, isLoggedIn, isDarkMode, title, captionClassName }: Props) {
  return (
    <>
      <span className={cx('mt-typography-caption', classes[captionClassName], isDarkMode && classes.captionDarkMode)}>
        {title}
      </span>
      <Orientation orientation={orientation} activeCurrency={activeCurrency} isLoggedIn={isLoggedIn} />
    </>
  )
}

export default OrientationContainer
